const HELP_TEXTS = {
  header: {
    owner:
      'This is a read-only field. It can only be changed in the Opportunity screen.',
    adOpsDelayedStartReasons:
      'Reason of the delayed campaign start. AdOps will insert & edit these before the Campaign push. The field will be visible to (S)PCs for communication purposes.',
    pcDelayedStartReasons:
      'Reasons for the Briefing delays. (S)PCs will insert & edit these before the Campaigns put the status Ready. The field will be visible to AdOps for communication purposes.',
    ccpHighlightedSkus:
      'Unless the Campaign is Pure Growth, this list of SKUs will be automatically pushed to the CCP system. Please ONLY enter your list of SKUs that are separated by a comma, space or line break.',
    useRecommendedColors:
      'Enabling this feature will push the campaigns with auto-selected background colors for CF placements and the lines will be automatically saved and synced on the CF end.',
    hasCFCampaignLevelSteering:
      'Enabling this feature will allow CLS (automated budget shift). This is only the initial state in SC and it will not sync, based on the changes on the ad servers',
    hasCCPCampaignLevelSteering:
      'Enabling this feature will allow CLS (automated budget shift). This is only the initial state in SC and it will not sync, based on the changes on the ad servers',
    requestChange:
      'Change Request cannot be used if any of the products are not pushed/locked yet.',
    timezone:
      'Please pick a timezone appropriate for the region that the campaign will run in.',
    merchantExclusivity:
      'OPTIMAL - Recommended. SKUs are allowed when not leading to the competitor’s sales.\n\nFULL - Not recommended, use only in case of explicit partner request. Only exclusive SKUs are allowed, it can block the delivery',
  },
  actionButtons: {
    productStatusChange:
      'You cannot change the product status back to Ready or Draft if the product is Pushed or Locked.',
    campaignPush: 'In order to Push a product, the status must be Ready.',
    zmsAmPushDisabled:
      'There are certain conditions that prevent pushing to Ad Manager.',
    productLock: 'In order to Lock a product, the status must be Ready.',
    overCCPLimit:
      'There are too many SKUs for this product. CCP has a limit of 5000 SKUs.',
    grantedVieCR:
      'Lines granted via change request need to be manually added to the delivery systems',
  },
  readOnlyFields: {
    collaboratorIds: 'This field is editable in the opportunity screen only.',
    additionalDetails:
      'This field is populated since Discretionary Media is selected as the commercial incentive.',
  },
  prioScore:
    'The Campaign Priority-Score calculation is based on the following factors: Brand Score (ZMS Revenues per Pool, NMV, Brand Type, etc.), Campaign budget, and Urgency (Campaign Type, Runtime). The Score varies from 1 to 5, where 1 represents the highest Priority.',
  manualInvoicing: 'The campaign status was moved from Ended back to Running.',
  manualInvoicingToolTip:
    'If there is a final invoice, either cancel it so that the system auto generates the next invoices, or create manual invoices after the final invoice',
  bulkEditor: {
    targeting:
      'Options for this dropdown will be displayed based on the selected campaign lines. If a catalog product is selected, the Themed Home extension will not be applicable. Additionally, if the selected campaign lines do not support targeting, this field will be disabled.',
  },
};

export default HELP_TEXTS;
